<mat-card class="dashboard_med_wrap">
    <div class="dashboard_inner content-area">

        <div class="message message-header">
            <mat-card-header>
                <prl-label value="label.dashboard.message.heading"/>
            </mat-card-header>
            <hr/>

            <div class="message-row message-row--header">
                <div class="message-left">
                    <div class="message-check">
                        <input (change)="toggleSelectAllMessages()" [(ngModel)]="selectAll" type="checkbox">
                    </div>

                    <mx-button [buttonModel]="deleteButton"/>
                    <mx-button [buttonModel]="readButton"/>
                    <mx-button [buttonModel]="newMessageButton"/>
                </div>
            </div>
        </div>

        <div class="message-row" [class.unread]="!message.read" (click)="onOpenMessage(message)"
             *ngFor="let message of messages | paginate: { itemsPerPage: pagination.pageSize, currentPage: pagination.currentPage }">
            <div class="message-left">
                <div class="message-check">
                    <input type="checkbox" [(ngModel)]="message.selected" (click)="$event.stopPropagation()"/>
                </div>
                @if (message.global) {
                    <span class="material-symbols-outlined">brand_awareness</span>
                }
                <div class="message-content">
                    <div class="message-sender">
                        {{message.sender}}
                    </div>
                    <div class="message-title">
                        {{message.title}}
                    </div>
                </div>
            </div>
            <div class="message-date">
                {{message.updatedOn | date:'dd/MM/yyyy h:mma'}}
            </div>
        </div>

        <div class="mxs-paginator">
            <div class="mxs-paginator_label">
                {{ 'Items per page: ' | translate }}
            </div>

            <mat-select
                    class="mxs-paginator_dropdown"
                    [(ngModel)]="pagination.pageSize"
                    (selectionChange)="onPageSizeChange()"
            >
                <mat-option *ngFor="let size of pageSizes" [value]="size">
                    {{ size }}
                </mat-option>
            </mat-select>
            <pagination-controls (pageChange)="pagination.currentPage = $event" autoHide="true"/>
        </div>

    </div>
</mat-card>